import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
// 引入vant
import Vant from 'vant'
import vantToast from './components/vant-toast.js';
import 'vant/lib/index.css'
import 'amfe-flexible'
import { checkIOSDevice } from './utils/deviceCheck';
checkIOSDevice();

Vue.use(Vant)
Vue.use(vantToast);

Vue.config.productionTip = false

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
